import React from "react";
import './style.css';

const Team = () => {
    return (
      <div className="teamContainer" id="team">
        <h2>OUR TEAM</h2>
        <div className="coachContainer">
          <img className="coachImg" src="coach.png" alt="coach" />
          <h3>valeryia beizer</h3>
          <p>
            master of sports of republic of belarus. winner and prize-winner of
            national and international competitions. international coaching
            experience more than 7 years
          </p>
        </div>
      </div>
    );
}

export default Team;